/**
 * Les modules masqués du menu, pour toute l'entreprise.
 *
 * Le menu comptait vingt entrées, dont quatre modules vides (À faire,
 * Prospection, Messagerie, Véhicules) : autant de choix à lire pour rien.
 * L'administrateur choisit ce que le menu montre ; le choix vaut pour tout le
 * monde et vit dans `organizations.parametres.menu`.
 *
 * Masquer n'interdit rien : l'écran reste ouvert à qui a le lien, et les
 * droits de chacun ne changent pas. Seul le menu s'allège.
 */

/** Ces modules ne se masquent pas : sans eux, plus moyen de revenir en arrière. */
export const MODULES_TOUJOURS_VISIBLES: readonly string[] = [
  'dashboard',
  'parametres',
  'personnalisation',
  'utilisateurs',
];

/**
 * Masqués tant que l'administrateur n'a rien choisi : les quatre modules
 * trouvés vides à l'audit du 06/10/2026. Un clic les fait revenir.
 */
export const MASQUES_PAR_DEFAUT: readonly string[] = [
  'taches',
  'prospection',
  'messagerie',
  'vehicules',
];

function estObjet(x: unknown): x is Record<string, unknown> {
  return typeof x === 'object' && x !== null && !Array.isArray(x);
}

/**
 * Les modules masqués, lus dans `organizations.parametres`.
 *
 * Rien d'enregistré : les masqués par défaut. Une liste enregistrée, même
 * vide, est le choix de l'administrateur et l'emporte. Ce qui n'est pas un
 * texte est ignoré, et un module toujours visible ne peut pas être masqué.
 */
export function modulesMasques(parametres: unknown): string[] {
  const menu = estObjet(parametres) ? parametres.menu : undefined;
  const brut = estObjet(menu) ? menu.masques : undefined;
  const liste = Array.isArray(brut) ? brut : MASQUES_PAR_DEFAUT;
  return [
    ...new Set(
      liste.filter(
        (x): x is string => typeof x === 'string' && !MODULES_TOUJOURS_VISIBLES.includes(x),
      ),
    ),
  ];
}

/**
 * Les paramètres de l'organisation, avec ce nouveau choix — et tout le reste
 * intact : les réglages SMS, la règle de pause… vivent dans le même objet.
 */
export function avecModulesMasques(
  parametres: unknown,
  masques: readonly string[],
): Record<string, unknown> {
  const base = estObjet(parametres) ? parametres : {};
  const menu = estObjet(base.menu) ? base.menu : {};
  return {
    ...base,
    menu: {
      ...menu,
      masques: [...new Set(masques)].filter((m) => !MODULES_TOUJOURS_VISIBLES.includes(m)),
    },
  };
}
